import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ShoppingBag, Heart, Sparkles } from 'lucide-react'
import { useCart } from '../context/CartContext'

const ProductCard = ({ product }) => {
  const { addToCart } = useCart()
  const navigate = useNavigate()

  const handleCardClick = () => {
    navigate(`/product/${product.id}`)
  }

  const handleAddToCart = (e) => {
    e.stopPropagation()
    addToCart(product)
  }

  return (
    <div 
      onClick={handleCardClick}
      className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
      data-component-path="client/src/components/ProductCard.jsx" data-component-line="20:4" data-component-id="client/src/components/ProductCard.jsx:20:4"
    >
      <div className="relative overflow-hidden aspect-square" data-component-path="client/src/components/ProductCard.jsx" data-component-line="24:6" data-component-id="client/src/components/ProductCard.jsx:24:6">
        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://images.pexels.com/photos/1454171/pexels-photo-1454171.jpeg?auto=compress&cs=tinysrgb&w=600'
          }}
          data-component-path="client/src/components/ProductCard.jsx" data-component-line="25:8" data-component-id="client/src/components/ProductCard.jsx:25:8"
        />
        <button 
          onClick={(e) => {
            e.stopPropagation()
          }}
          className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-pink-50"
          data-component-path="client/src/components/ProductCard.jsx" data-component-line="35:8" data-component-id="client/src/components/ProductCard.jsx:35:8"
        >
          <Heart className="w-5 h-5 text-gray-700" data-component-path="client/src/components/ProductCard.jsx" data-component-line="41:10" data-component-id="client/src/components/ProductCard.jsx:41:10" />
        </button>
        {product.badge && (
          <span className="absolute top-3 left-3 bg-champagne-600 text-white text-xs font-medium px-3 py-1 rounded-full" data-component-path="client/src/components/ProductCard.jsx" data-component-line="44:10" data-component-id="client/src/components/ProductCard.jsx:44:10">
            {product.badge}
          </span>
        )}
        {product.special && (
          <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center gap-1.5" data-component-path="client/src/components/ProductCard.jsx" data-component-line="49:10" data-component-id="client/src/components/ProductCard.jsx:49:10">
            <Sparkles className="w-3.5 h-3.5 text-champagne-600" data-component-path="client/src/components/ProductCard.jsx" data-component-line="50:12" data-component-id="client/src/components/ProductCard.jsx:50:12" />
            <span className="text-xs font-medium text-gray-800" data-component-path="client/src/components/ProductCard.jsx" data-component-line="51:12" data-component-id="client/src/components/ProductCard.jsx:51:12">Handcrafted</span>
          </div>
        )}
      </div>
      
      <div className="p-4" data-component-path="client/src/components/ProductCard.jsx" data-component-line="56:6" data-component-id="client/src/components/ProductCard.jsx:56:6">
        <h3 className="font-serif text-lg font-semibold text-gray-800 mb-1" data-component-path="client/src/components/ProductCard.jsx" data-component-line="57:8" data-component-id="client/src/components/ProductCard.jsx:57:8">
          {product.name}
        </h3>
        <p className="text-sm text-gray-600 mb-2" data-component-path="client/src/components/ProductCard.jsx" data-component-line="60:8" data-component-id="client/src/components/ProductCard.jsx:60:8">{product.category}</p>
        
        {/* Product Description */}
        <p className="text-xs text-gray-500 mb-3 line-clamp-2 min-h-[32px]" data-component-path="client/src/components/ProductCard.jsx" data-component-line="63:8" data-component-id="client/src/components/ProductCard.jsx:63:8">
          {product.description}
        </p>

        {/* Material Info */}
        {product.material && (
          <div className="mb-3" data-component-path="client/src/components/ProductCard.jsx" data-component-line="69:10" data-component-id="client/src/components/ProductCard.jsx:69:10">
            <span className="text-xs text-champagne-700 font-medium bg-champagne-50 px-2 py-1 rounded" data-component-path="client/src/components/ProductCard.jsx" data-component-line="70:12" data-component-id="client/src/components/ProductCard.jsx:70:12">
              {product.material}
            </span>
          </div>
        )}
        
        <div className="flex items-center justify-between" data-component-path="client/src/components/ProductCard.jsx" data-component-line="76:8" data-component-id="client/src/components/ProductCard.jsx:76:8">
          <div data-component-path="client/src/components/ProductCard.jsx" data-component-line="77:10" data-component-id="client/src/components/ProductCard.jsx:77:10">
            <span className="text-xl font-bold text-champagne-600" data-component-path="client/src/components/ProductCard.jsx" data-component-line="78:12" data-component-id="client/src/components/ProductCard.jsx:78:12">₹{product.price.toLocaleString()}</span>
            {product.originalPrice && (
              <span className="text-sm text-gray-400 line-through ml-2" data-component-path="client/src/components/ProductCard.jsx" data-component-line="80:14" data-component-id="client/src/components/ProductCard.jsx:80:14">
                ₹{product.originalPrice.toLocaleString()}
              </span>
            )}
            {product.original_price && !product.originalPrice && (
              <span className="text-sm text-gray-400 line-through ml-2">
                ₹{product.original_price.toLocaleString()}
              </span>
            )}
          </div>
          <button 
            onClick={handleAddToCart}
            className="bg-champagne-600 text-white p-2 rounded-full hover:bg-champagne-700 transition-colors shadow-md hover:shadow-lg flex items-center justify-center"
            data-component-path="client/src/components/ProductCard.jsx" data-component-line="86:10" data-component-id="client/src/components/ProductCard.jsx:86:10"
          >
            <ShoppingBag className="w-5 h-5" data-component-path="client/src/components/ProductCard.jsx" data-component-line="90:12" data-component-id="client/src/components/ProductCard.jsx:90:12" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
